import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from "@angular/material";
import { Estudo } from "../estudo/estudo";

@Component({
  selector: "comparacao.dialog",
  templateUrl: "./comparacao.dialog.html",
  styleUrls: ["comparacao.dialog.css"]
})
export class ComparacaoDialog {
  public list: Estudo[];
  public mostarLista: boolean;
  public estudosSelecionados: Estudo[];

  constructor(
    public dialogRef: MatDialogRef<number>,
    private mensagem: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: Estudo[]
  ) {
    this.list = data;
    this.mostarLista = true;
  }

  selecionarEstudo(estudosSelecionadosEmitido:Estudo[]){
    if(estudosSelecionadosEmitido && estudosSelecionadosEmitido.length != 2){
      this.mensagem.open("Selecione exatamente dois estudos.", 'X', {duration: 5000});
      estudosSelecionadosEmitido = null;
    }else{
      this.estudosSelecionados = estudosSelecionadosEmitido;
      this.mostarLista = false;
    }
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
